import { Trans } from '@lingui/react/macro';

import styles from './BwaSusa.module.css';
import { TOfferDataRequirement } from '../../../../../types';
import DocumentRequirement from '../../../DocumentRequirement/DocumentRequirement';
import { documentTypes } from '../../../tradingHistory.helpers';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
export const BwaSusa = ({ isOptional, isSubmitted, status }: TProps) => {
  return (
    <DocumentRequirement
      title={
        <>
          <Trans>Current BWA and SuSa</Trans>
          <span className={styles.smallTitle}>
            (<Trans>Not older than 4 months</Trans>)
          </span>
        </>
      }
      documentType={documentTypes.bwa_susa_hochladen}
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <>
        <ul>
          <li>
            Sie können sich die BWA aus Ihrer Buchhaltungssoftware herunterladen
            oder bei Ihrem Steuerberater anfragen
          </li>
          <li>
            Alle BWAs sollten Firmenname, Umsatzerlöse, Wareneinkauf, Kosten
            inkl. Abschreibungen, Zinsaufwände & vorläufiges Ergebnis zeigen
          </li>
        </ul>
      </>
    </DocumentRequirement>
  );
};
